import FormMetaReducer from 'modules/Forms/FormMeta/store/reducer'

export const FormsSagas = []

export const FormsReducers = {
  'forms/meta': FormMetaReducer,
}
